const recipes = [
  {
    id: "r1",
    slug: "brown-butter-chocolate-chip-cookies",
    title: "Brown Butter Chocolate Chip Cookies",
    emoji: "🍪",
    category: "Cookies",
    difficulty: "Easy",
    time: "45 min",
    servings: 24,
    tags: ["chocolate", "butter", "classic", "beginner-friendly"],
    date: "Apr 2026",
    featured: true,
    description:
      "Deeply nutty brown butter cookies with crisp edges, chewy centres, and pools of melted dark chocolate.",
    color: "#fff0e8",
    accentColor: "#d4622a",
    ingredients: [
      "225g unsalted butter",
      "200g dark brown sugar",
      "100g caster sugar",
      "2 large eggs + 1 yolk (room temp)",
      "2 tsp vanilla extract",
      "280g all-purpose flour",
      "1 tsp baking soda",
      "1 tsp fine sea salt",
      "300g dark chocolate (chopped)",
    ],
    steps: [
      "Brown butter in a light pan over medium heat, stirring constantly until golden with brown specks and nutty aroma. Immediately transfer and cool 10–15 minutes.",
      "Whisk sugars into warm (not hot) butter until glossy.",
      "Add eggs and yolk one at a time, whisking vigorously for 2–3 minutes until thick and emulsified.",
      "Whisk together flour, baking soda, and salt separately.",
      "Fold dry ingredients into wet using a spatula until just combined.",
      "Fold in chopped chocolate.",
      "Rest dough 30–60 minutes (or chill overnight for deeper flavour).",
      "Scoop 60g portions onto tray, spaced well apart.",
      "Bake at 175°C for 10–12 minutes until edges are set but centres soft.",
      "Cool on tray — they continue cooking from residual heat.",
    ],
    tips: "Whisking eggs properly creates structure. Slight underbake = chewy centres.",
  },

  {
    id: "r2",
    slug: "single-serve-chocolate-cookie",
    title: "Single Serve Chocolate Cookie",
    emoji: "🍪",
    category: "Cookies",
    difficulty: "Easy",
    time: "15 min",
    servings: 1,
    tags: ["quick", "single-serve"],
    date: "Apr 2026",
    featured: false,
    description: "A perfectly balanced single cookie — crisp edges, molten center.",
    color: "#fff4ec",
    accentColor: "#b85c38",
    ingredients: [
      "15g butter",
      "10g brown sugar",
      "10g white sugar",
      "1 egg yolk",
      "25g flour",
      "pinch baking soda",
      "pinch salt",
      "30g chocolate chunks",
    ],
    steps: [
      "Preheat oven to 180°C.",
      "Melt butter until just liquid, not hot.",
      "Mix in sugars until smooth.",
      "Add egg yolk and whisk until glossy.",
      "Fold in flour, baking soda, and salt until just combined.",
      "Fold in chocolate chunks.",
      "Shape into a thick cookie puck.",
      "Bake for 8–10 minutes until edges are set and centre soft.",
      "Rest 5 minutes before eating — structure sets as it cools.",
    ],
    tips: "Thickness = gooey centre. If flat, chill dough 5 mins before baking.",
  },

  {
    id: "r3",
    slug: "brookies",
    title: "Brookies (Brownie + Cookie)",
    emoji: "🍫",
    category: "Dessert",
    difficulty: "Medium",
    time: "55 min",
    servings: 12,
    tags: ["brownie", "cookie", "hybrid"],
    date: "Apr 2026",
    featured: true,
    description: "Fudgy espresso brownie base topped with chewy cookie dough.",
    color: "#fbe9e7",
    accentColor: "#8d3b2c",
    ingredients: [
      // Brownie layer
      "120g dark chocolate",
      "100g butter",
      "150g sugar",
      "2 eggs",
      "80g flour",
      "1 tbsp cocoa powder",
      "1 tsp espresso powder",
      "pinch salt",
      // Cookie layer
      "Chocolate chip cookie dough (half batch)",
    ],
    steps: [
      "Preheat oven to 180°C and line pan.",
      "Melt chocolate and butter together until smooth.",
      "Whisk in sugar, then eggs one at a time.",
      "Fold in flour, cocoa powder, espresso powder, and salt.",
      "Pour brownie batter into pan.",
      "Drop chunks of cookie dough evenly on top.",
      "Lightly press without mixing layers.",
      "Bake for 25–30 minutes until top is golden and centre slightly soft.",
      "Cool completely before slicing for clean layers.",
    ],
    tips: "Espresso enhances chocolate flavour. Slight underbake = fudgy centre.",
  },

  {
    id: "r4",
    slug: "stuffed-nutella-cookies",
    title: "Stuffed Nutella Cookies",
    emoji: "🍪",
    category: "Cookies",
    difficulty: "Medium",
    time: "45 min",
    servings: 10,
    tags: ["nutella", "stuffed"],
    date: "Apr 2026",
    featured: false,
    description: "Thick bakery-style cookies with molten Nutella centers.",
    color: "#fff1e6",
    accentColor: "#a44a3f",
    ingredients: [
      "200g all-purpose flour",
      "120g butter",
      "100g brown sugar",
      "50g white sugar",
      "1 egg",
      "1 tsp vanilla",
      "1/2 tsp baking soda",
      "1/2 tsp salt",
      "Nutella (frozen scoops)",
    ],
    steps: [
      "Freeze Nutella scoops for at least 30–45 minutes.",
      "Cream butter and sugars until light and fluffy.",
      "Add egg and vanilla, mix until smooth.",
      "Mix in flour, baking soda, and salt.",
      "Chill dough 20 minutes for easier handling.",
      "Flatten dough, place Nutella inside, and seal completely.",
      "Roll into thick balls and place on tray.",
      "Bake at 180°C for 12–14 minutes.",
      "Cool slightly — centres remain molten.",
    ],
    tips: "Seal edges tightly or Nutella will leak. Chill dough if too soft.",
  },

  {
    id: "r5",
    slug: "almond-flour-cookies",
    title: "Almond Flour Cookies",
    emoji: "🌰",
    category: "Cookies",
    difficulty: "Easy",
    time: "20 min",
    servings: 12,
    tags: ["gluten-free", "almond"],
    date: "Apr 2026",
    featured: false,
    description: "Soft, chewy gluten-free cookies with crisp edges.",
    color: "#fdf6e3",
    accentColor: "#c89b3c",
    ingredients: [
      "200g almond flour",
      "80g sugar",
      "1 egg",
      "1 tsp vanilla",
      "1/2 tsp baking powder",
      "pinch salt",
    ],
    steps: [
      "Preheat oven to 170°C and line tray.",
      "Mix almond flour, sugar, baking powder, and salt.",
      "Add egg and vanilla, mix into soft dough.",
      "Scoop and shape into balls.",
      "Flatten slightly — they don’t spread much.",
      "Bake for 10–12 minutes until lightly golden.",
      "Cool completely before handling.",
    ],
    tips: "They firm up as they cool — don’t overbake or they’ll dry out.",
  },
];

export default recipes;